import _slicedToArray from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useMemo } from 'react';
import { formatContent } from '../utils';
export var useSectionItem = function useSectionItem(_ref) {
  var section = _ref.section,
      questions = _ref.questions,
      selectedFormItemId = _ref.selectedFormItemId;
  var sectionId = section.id.toString();
  var isSelected = selectedFormItemId === sectionId;
  var formattedTitle = useMemo(function () {
    return formatContent(section.title);
  }, [section.title]);
  var formattedDescription = useMemo(function () {
    return formatContent(section.description || 'Instructional text');
  }, [section.description]);
  var hasQuestions = useMemo(function () {
    return questions && questions.length > 0;
  }, [questions]); // Calculate sectionPoints from questions array to ensure real-time updates

  var sectionPoints = useMemo(function () {
    if (!questions) return 0;
    return questions.reduce(function (sum, q) {
      return sum + (Number(q.score) || 0);
    }, 0);
  }, [questions]);
  var isLoading = useMemo(function () {
    return section.totalScore === null || section.totalScore === undefined;
  }, [section.totalScore]); // Helper function to convert number to Roman numeral

  var convertToRomanNumeral = function convertToRomanNumeral(num) {
    var romanNumerals = [[1000, 'M'], [900, 'CM'], [500, 'D'], [400, 'CD'], [100, 'C'], [90, 'XC'], [50, 'L'], [40, 'XL'], [10, 'X'], [9, 'IX'], [5, 'V'], [4, 'IV'], [1, 'I']];
    var result = '';

    for (var _i = 0, _romanNumerals = romanNumerals; _i < _romanNumerals.length; _i++) {
      var _romanNumerals$_i = _slicedToArray(_romanNumerals[_i], 2),
          value = _romanNumerals$_i[0],
          numeral = _romanNumerals$_i[1];

      var count = Math.floor(num / value);
      result += numeral.repeat(count);
      num -= value * count;
    }

    return result;
  };

  return {
    sectionId: sectionId,
    isSelected: isSelected,
    formattedTitle: formattedTitle,
    formattedDescription: formattedDescription,
    hasQuestions: hasQuestions,
    sectionPoints: sectionPoints,
    isLoading: isLoading,
    convertToRomanNumeral: convertToRomanNumeral
  };
};